// Sweet Sprinkles Package Builder, bundled production build. Compiled from .jsx via Babel.
// Bundle order: icons -> cart -> steps -> app. Requires React + ReactDOM in scope.

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// Icon component, minimal stroke SVGs to replace emojis throughout the builder.
// Usage: <Icon name="birthday" size={22} />

function Icon({
  name,
  size = 22,
  stroke = 1.8,
  className = ''
}) {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: stroke,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className
  };
  switch (name) {
    // ----- Occasions -----
    case 'birthday':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "4",
        y: "11",
        width: "16",
        height: "9",
        rx: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "4",
        y1: "15",
        x2: "20",
        y2: "15"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "11",
        x2: "12",
        y2: "6"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 6 Q10.5 4 12 2 Q13.5 4 12 6"
      }));
    case 'wedding':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "9",
        cy: "14",
        r: "5"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "15",
        cy: "14",
        r: "5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7 7 L9 4 L11 7"
      }));
    case 'corporate':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "3",
        y: "8",
        width: "18",
        height: "12",
        rx: "1.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 8 V6.5 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 V8"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "3",
        y1: "14",
        x2: "21",
        y2: "14"
      }));
    case 'holiday':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "4",
        y: "10",
        width: "16",
        height: "10",
        rx: "1"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "4",
        y1: "13",
        x2: "20",
        y2: "13"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "10",
        x2: "12",
        y2: "20"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 10 Q9 7 7 7 Q5 7 6 9 Q7 10 12 10"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 10 Q15 7 17 7 Q19 7 18 9 Q17 10 12 10"
      }));
    case 'baby':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M9 3 H15 V6 H9 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7 8 V18 a3 3 0 0 0 3 3 h4 a3 3 0 0 0 3 -3 V8 Z"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "7",
        y1: "11",
        x2: "17",
        y2: "11"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "9",
        y1: "6",
        x2: "15",
        y2: "8"
      }));
    case 'thanks':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 20 C6 16 3 12 3 8.5 A4.5 4.5 0 0 1 12 6 A4.5 4.5 0 0 1 21 8.5 C21 12 18 16 12 20 Z"
      }));
    case 'other':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 3 L13.5 10.5 L21 12 L13.5 13.5 L12 21 L10.5 13.5 L3 12 L10.5 10.5 Z"
      }));

    // ----- Diets -----
    case 'vegan':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M20 4 C12 4 4 8 4 16 Q4 19 7 20"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4 20 L14 10"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M20 4 C20 12 16 18 8 20"
      }));
    case 'vegetarian':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 20 V13"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 13 C6 12 4 8 4 5 C9 5 12 8 12 13"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 13 C18 12 20 8 20 5 C15 5 12 8 12 13"
      }));
    case 'gf':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 7 Q9 6 7 8 Q9 10 12 9"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 7 Q15 6 17 8 Q15 10 12 9"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 12 Q9 11 7 13 Q9 15 12 14"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 12 Q15 11 17 13 Q15 15 12 14"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "4",
        y1: "20",
        x2: "20",
        y2: "4",
        strokeWidth: "2.2"
      }));
    case 'halal':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M17 4 A8 8 0 1 0 17 20 A6 6 0 1 1 17 4 Z"
      }));
    case 'kosher':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("polygon", {
        points: "12 3 19.5 16 4.5 16"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "12 21 4.5 8 19.5 8"
      }));
    case 'nutfree':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18",
        strokeWidth: "2.2"
      }));

    // ----- Allergens -----
    case 'gluten':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 6 Q9 5 7 7 Q9 9 12 8"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 6 Q15 5 17 7 Q15 9 12 8"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 11 Q9 10 7 12 Q9 14 12 13"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 11 Q15 10 17 12 Q15 14 12 13"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 16 Q9 15 7 17 Q9 19 12 18"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 16 Q15 15 17 17 Q15 19 12 18"
      }));
    case 'dairy':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "9",
        y: "2",
        width: "6",
        height: "4",
        rx: "0.5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M7 6 V19 a2 2 0 0 0 2 2 h6 a2 2 0 0 0 2 -2 V6 Z"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "7",
        y1: "10",
        x2: "17",
        y2: "10"
      }));
    case 'eggs':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("ellipse", {
        cx: "12",
        cy: "13",
        rx: "6",
        ry: "8"
      }));
    case 'treenuts':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 3 Q7 3 7 9 Q7 13 12 21 Q17 13 17 9 Q17 3 12 3 Z"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "9",
        y1: "10",
        x2: "15",
        y2: "10"
      }));
    case 'peanuts':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 3 Q7 3 7 8 Q7 10 9 11 Q7 12 7 14 Q7 21 12 21 Q17 21 17 14 Q17 12 15 11 Q17 10 17 8 Q17 3 12 3 Z"
      }));
    case 'soy':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M9 5 Q4 6 4 12 Q4 18 10 19 Q15 19 14 14 Q15 11 18 11 Q21 9 18 6 Q14 4 9 5 Z"
      }));
    case 'sesame':
      return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
        strokeWidth: stroke * 0.7
      }), /*#__PURE__*/React.createElement("ellipse", {
        cx: "8",
        cy: "11",
        rx: "1.6",
        ry: "2.4"
      }), /*#__PURE__*/React.createElement("ellipse", {
        cx: "12",
        cy: "15",
        rx: "1.6",
        ry: "2.4"
      }), /*#__PURE__*/React.createElement("ellipse", {
        cx: "16",
        cy: "11",
        rx: "1.6",
        ry: "2.4"
      }), /*#__PURE__*/React.createElement("ellipse", {
        cx: "10",
        cy: "6.5",
        rx: "1.6",
        ry: "2.4"
      }), /*#__PURE__*/React.createElement("ellipse", {
        cx: "14",
        cy: "6.5",
        rx: "1.6",
        ry: "2.4"
      }));

    // ----- Delivery windows -----
    case 'sunrise':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("line", {
        x1: "3",
        y1: "20",
        x2: "21",
        y2: "20"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6 17 A6 6 0 0 1 18 17"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "9"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "3",
        x2: "10",
        y2: "5"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "3",
        x2: "14",
        y2: "5"
      }));
    case 'sun':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "2.5",
        x2: "12",
        y2: "5"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "19",
        x2: "12",
        y2: "21.5"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "2.5",
        y1: "12",
        x2: "5",
        y2: "12"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "19",
        y1: "12",
        x2: "21.5",
        y2: "12"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "5.3",
        y1: "5.3",
        x2: "7",
        y2: "7"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "17",
        y1: "17",
        x2: "18.7",
        y2: "18.7"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "5.3",
        y1: "18.7",
        x2: "7",
        y2: "17"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "17",
        y1: "7",
        x2: "18.7",
        y2: "5.3"
      }));
    case 'moon':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M20 14.5 A8 8 0 1 1 9.5 4 A6 6 0 0 0 20 14.5 Z"
      }));

    // ----- Misc -----
    case 'bulb':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M9 20 H15"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M10 22 H14"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 14 Q5 11 8 7 Q12 4 16 7 Q19 11 16 14 V18 H8 V14 Z"
      }));
    case 'warn':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 3 L22 20 H2 Z"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "9",
        x2: "12",
        y2: "14"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "12",
        y1: "17",
        x2: "12",
        y2: "17.5",
        strokeWidth: "2.5"
      }));
    case 'check':
      return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
        strokeWidth: stroke + 0.6
      }), /*#__PURE__*/React.createElement("polyline", {
        points: "5 12 10 17 19 7"
      }));
    case 'search-empty':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "11",
        cy: "11",
        r: "6"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "20",
        y1: "20",
        x2: "15.5",
        y2: "15.5"
      }));

    // ----- Product category icons -----
    case 'cat-breads':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M3 14 Q3 8 8 8 Q10 5 12 8 Q14 5 16 8 Q21 8 21 14 L20 18 H4 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 11 L8 16"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 11 L12 16"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M16 11 L16 16"
      }));
    case 'cat-muffins':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M5 11 Q5 5 12 5 Q19 5 19 11 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5 11 L4 14 a2 2 0 0 0 2 2 h12 a2 2 0 0 0 2 -2 L19 11 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9 7 L9 5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13 7 L13 4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15 8 L16 6"
      }));
    case 'cat-cakes':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "4",
        y: "14",
        width: "16",
        height: "6",
        rx: "1"
      }), /*#__PURE__*/React.createElement("rect", {
        x: "6",
        y: "9",
        width: "12",
        height: "5",
        rx: "1"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 9 L12 5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 5 Q10.5 3 12 1.5 Q13.5 3 12 5"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "4",
        y1: "17",
        x2: "20",
        y2: "17"
      }));
    case 'cat-cookies':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "9"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "9",
        cy: "9",
        r: "1",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "15",
        cy: "10",
        r: "1",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "13",
        cy: "14",
        r: "1",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "9",
        cy: "15",
        r: "1",
        fill: "currentColor",
        stroke: "none"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "17",
        cy: "14",
        r: "1",
        fill: "currentColor",
        stroke: "none"
      }));
    case 'cat-bonbons':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6 12 L18 12"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 6 L12 18"
      }));
    case 'cat-seasonal':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M12 3 L12 21"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M3 12 L21 12"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5 5 L19 19"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19 5 L5 19"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
      }));

    // ----- Cart / illustration -----
    case 'gift-bag':
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
        d: "M5 8 H19 L18 21 H6 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 8 V6 a4 4 0 0 1 8 0 V8"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "9",
        y1: "12",
        x2: "9",
        y2: "15"
      }), /*#__PURE__*/React.createElement("line", {
        x1: "15",
        y1: "12",
        x2: "15",
        y2: "15"
      }));
    default:
      return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8"
      }));
  }
}
Object.assign(window, {
  Icon
});


// Cart sidebar + tier progress.
// Money formatting reads window.SS_FMT (set by app.jsx from the Liquid-injected moneyFormat)
// so a single Shopify "${{amount}}" / "${{amount_no_decimals}}" string controls display.

const fmt = n => window.SS_FMT ? window.SS_FMT(n) : '$' + (Math.round(n * 100) / 100).toFixed(2);
function TierProgress({
  subtotal,
  tiers
}) {
  const sorted = [...tiers].sort((a, b) => a.threshold - b.threshold);
  const reached = sorted.filter(t => subtotal >= t.threshold);
  const current = reached[reached.length - 1] || null;
  const next = sorted.find(t => subtotal < t.threshold) || null;
  const maxThreshold = sorted[sorted.length - 1]?.threshold || 1;
  const pct = Math.min(100, subtotal / maxThreshold * 100);
  return /*#__PURE__*/React.createElement("div", {
    className: "tier-progress"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier-headline"
  }, /*#__PURE__*/React.createElement("span", null, current ? `${(current.discount * 100).toFixed(0)}% bulk discount unlocked` : 'Bulk discount progress'), /*#__PURE__*/React.createElement("strong", null, fmt(subtotal))), /*#__PURE__*/React.createElement("div", {
    className: "tier-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier-bar-fill",
    style: {
      width: pct + '%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "tier-ticks"
  }, sorted.map(t => /*#__PURE__*/React.createElement("div", {
    key: t.threshold,
    className: 'tier-tick ' + (subtotal >= t.threshold ? 'passed' : ''),
    style: { left: (t.threshold / maxThreshold * 100) + '%' }
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("span", null, fmt(t.threshold)), /*#__PURE__*/React.createElement("span", null, (t.discount * 100).toFixed(0), "%")))), next ? /*#__PURE__*/React.createElement("div", {
    className: "tier-message"
  }, "Add ", /*#__PURE__*/React.createElement("strong", null, fmt(next.threshold - subtotal)), " more to unlock ", /*#__PURE__*/React.createElement("strong", null, (next.discount * 100).toFixed(0), "% off"), " your entire order.") : current ? /*#__PURE__*/React.createElement("div", {
    className: "tier-unlocked"
  }, /*#__PURE__*/React.createElement(CheckIcon, null), " Maximum bulk discount applied. You're saving big!") : /*#__PURE__*/React.createElement("div", {
    className: "tier-message"
  }, "Start adding treats to unlock bulk savings."));
}
function CartSidebar({
  cart,
  products,
  subtotal,
  discount,
  tiers,
  removeFromCart,
  setQty,
  goToStep,
  eventDetails,
  hideTier,
  deliveryFlatFee,
  freeDeliveryOver
}) {
  const items = Object.entries(cart).filter(([, q]) => q > 0);
  const productMap = Object.fromEntries(products.map(p => [p.id, p]));
  const totalItems = items.reduce((s, [, q]) => s + q, 0);
  const sortedTiers = [...tiers].sort((a, b) => a.threshold - b.threshold);
  const currentTier = sortedTiers.filter(t => subtotal >= t.threshold).pop();
  const freeOver = typeof freeDeliveryOver === 'number' ? freeDeliveryOver : 50;
  const flatFee = typeof deliveryFlatFee === 'number' ? deliveryFlatFee : 15;
  const deliveryCost = totalItems === 0 ? 0 : subtotal > freeOver ? 0 : flatFee;
  const total = subtotal - discount + deliveryCost;
  return /*#__PURE__*/React.createElement("aside", {
    className: "cart-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cart-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Your package"), /*#__PURE__*/React.createElement("div", {
    className: "cart-sub"
  }, totalItems === 0 ? 'No items yet' : `${totalItems} item${totalItems === 1 ? '' : 's'}`, eventDetails?.guests ? ` - ${eventDetails.guests} guests` : '')), currentTier && /*#__PURE__*/React.createElement("div", {
    className: "discount-badge"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 12,
    stroke: 3
  }), Math.round(currentTier.discount * 100), "% off")), !hideTier && /*#__PURE__*/React.createElement(TierProgress, {
    subtotal: subtotal,
    tiers: tiers
  }), /*#__PURE__*/React.createElement("div", {
    className: "cart-items"
  }, items.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "cart-empty"
  }, /*#__PURE__*/React.createElement("div", {
    className: "em-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "gift-bag",
    size: 28
  })), /*#__PURE__*/React.createElement("strong", null, "Your package is empty"), /*#__PURE__*/React.createElement("p", null, "Treats you add will land here in real time, with bulk savings stacked on top.")) : items.map(([id, qty]) => {
    const p = productMap[id];
    if (!p) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "cart-row",
      key: id
    }, /*#__PURE__*/React.createElement("div", {
      className: "cart-thumb"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: `cat-${p.cat}`,
      size: 22
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "cart-name"
    }, p.name), /*#__PURE__*/React.createElement("div", {
      className: "cart-meta"
    }, /*#__PURE__*/React.createElement("span", null, qty, " \xD7 ", fmt(p.price)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => setQty(id, qty - 1),
      "aria-label": "Decrease"
    }, "\u2212"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => setQty(id, qty + 1),
      "aria-label": "Increase"
    }, "+"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => removeFromCart(id)
    }, "remove"))), /*#__PURE__*/React.createElement("div", {
      className: "cart-price"
    }, fmt(p.price * qty)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "cart-totals"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cart-row-line"
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", null, fmt(subtotal))), discount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "cart-row-line discount"
  }, /*#__PURE__*/React.createElement("span", null, "Bulk discount"), /*#__PURE__*/React.createElement("span", null, "\u2212", fmt(discount))), /*#__PURE__*/React.createElement("div", {
    className: "cart-row-line"
  }, /*#__PURE__*/React.createElement("span", null, "Delivery"), /*#__PURE__*/React.createElement("span", null, totalItems === 0 ? '--' : deliveryCost === 0 ? 'FREE' : fmt(flatFee))), /*#__PURE__*/React.createElement("div", {
    className: "cart-row-line total"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, fmt(total)))));
}
function CartIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "21",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "21",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"
  }));
}
function CheckIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
}
Object.assign(window, {
  CartSidebar,
  TierProgress,
  CartIcon,
  CheckIcon,
  fmt
});


// All step components for the package builder. Each step receives the data it needs via
// props; nothing reads global product/occasion/allergen lists directly, that data is
// owned by PackageBuilder (which sources it from window.SS_BUILDER_CONFIG).

// Reusable: editable + steppable quantity input
function QtyInput({
  value,
  onChange,
  min = 0,
  max = 9999,
  step = 1,
  size
}) {
  const [draft, setDraft] = React.useState(String(value));
  React.useEffect(() => {
    setDraft(String(value));
  }, [value]);
  const commit = raw => {
    if (raw === '' || raw === '-') {
      onChange(min);
      setDraft(String(min));
      return;
    }
    let n = parseInt(raw, 10);
    if (isNaN(n)) n = min;
    n = Math.max(min, Math.min(max, n));
    onChange(n);
    setDraft(String(n));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'qty' + (size === 'lg' ? ' lg' : '')
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => onChange(Math.max(min, value - step)),
    disabled: value <= min
  }, "\u2212"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    inputMode: "numeric",
    className: "qty-val",
    value: draft,
    onChange: e => {
      const v = e.target.value.replace(/[^0-9]/g, '');
      setDraft(v);
    },
    onBlur: e => commit(e.target.value),
    onKeyDown: e => {
      if (e.key === 'Enter') {
        commit(e.target.value);
        e.target.blur();
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        onChange(Math.min(max, value + step));
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        onChange(Math.max(min, value - step));
      }
    },
    onFocus: e => e.target.select(),
    "aria-label": "Quantity"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => onChange(Math.min(max, value + step)),
    disabled: value >= max
  }, "+"));
}

// ============= Step 1: Event details =============
function StepEvent({
  data,
  occasions,
  setData,
  onNext
}) {
  const valid = data.occasion && data.guests > 0 && data.eventName.trim().length > 0;
  const guestDots = Math.min(50, data.guests);
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 01 \xB7 Tell us about the event"), /*#__PURE__*/React.createElement("h2", null, "Let's plan something delicious."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Start with the basics, we'll use this to suggest the right quantities and flag any timing constraints."), /*#__PURE__*/React.createElement("div", {
    className: "field-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "What's the occasion?"), /*#__PURE__*/React.createElement("div", {
    className: "chip-grid"
  }, occasions.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.id,
    type: "button",
    className: 'chip ' + (data.occasion === o.id ? 'pink selected' : ''),
    onClick: () => setData({
      ...data,
      occasion: o.id
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "chip-emoji"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: o.icon,
    size: 16
  })), o.name)))), /*#__PURE__*/React.createElement("div", {
    className: "field-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Event name ", /*#__PURE__*/React.createElement("span", {
    className: "opt"
  }, "(internal label, e.g. \"Sara's 30th\")")), /*#__PURE__*/React.createElement("input", {
    className: "input",
    type: "text",
    value: data.eventName,
    onChange: e => setData({
      ...data,
      eventName: e.target.value
    }),
    placeholder: "Give your package a name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Approximate guest count"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(QtyInput, {
    value: data.guests,
    step: 5,
    min: 0,
    max: 2000,
    onChange: v => setData({
      ...data,
      guests: v
    }),
    size: "lg"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-soft)',
      fontSize: 13
    }
  }, "guests")), /*#__PURE__*/React.createElement("div", {
    className: "guests-vis"
  }, Array.from({
    length: 50
  }).map((_, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    className: 'gv ' + (i < guestDots ? 'on' : '')
  })), data.guests > 50 && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11,
      color: 'var(--ink-soft)',
      marginLeft: 6
    }
  }, "+", data.guests - 50)))), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Anything else we should know? ", /*#__PURE__*/React.createElement("span", {
    className: "opt"
  }, "(optional)")), /*#__PURE__*/React.createElement("textarea", {
    className: "textarea",
    value: data.notes,
    onChange: e => setData({
      ...data,
      notes: e.target.value
    }),
    placeholder: "e.g. 'surprise party, please call before arriving' or 'corporate logo on the cake'"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    disabled: !valid,
    onClick: onNext
  }, "Continue \xB7 Dietary & allergens \u2192")));
}

// ============= Step 2: Dietary & allergens =============
function StepDietary({
  data,
  allergenLabels,
  setData,
  onNext,
  onBack
}) {
  const toggleAllergen = id => {
    const set = new Set(data.allergens);
    set.has(id) ? set.delete(id) : set.add(id);
    setData({
      ...data,
      allergens: [...set]
    });
  };
  const toggleDiet = id => {
    const set = new Set(data.diets);
    set.has(id) ? set.delete(id) : set.add(id);
    setData({
      ...data,
      diets: [...set]
    });
  };
  const diets = [{
    id: 'vegan',
    name: 'Vegan',
    desc: 'No animal products',
    icon: 'vegan'
  }, {
    id: 'vegetarian',
    name: 'Vegetarian',
    desc: 'No meat',
    icon: 'vegetarian'
  }, {
    id: 'gf',
    name: 'Gluten-free',
    desc: 'No wheat or gluten',
    icon: 'gf'
  }, {
    id: 'halal',
    name: 'Halal',
    desc: 'Halal-certified',
    icon: 'halal'
  }, {
    id: 'kosher',
    name: 'Kosher',
    desc: 'Kosher-certified',
    icon: 'kosher'
  }, {
    id: 'nuts',
    name: 'Nut-free',
    desc: 'No tree nuts/peanuts',
    icon: 'nutfree'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 02 \xB7 Dietary & allergens"), /*#__PURE__*/React.createElement("h2", null, "Anything we should avoid?"), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Tick everything that applies, we'll filter the menu in the next step so you only see safe options."), /*#__PURE__*/React.createElement("div", {
    className: "callout warn"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      flexShrink: 0,
      color: 'var(--warn)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "warn",
    size: 22
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "A note about our kitchen"), "Our home-based kitchen handles nuts, peanuts, dairy, eggs, wheat and sesame. We can't guarantee zero cross-contact. Please let us know if anyone has a severe allergy.")), /*#__PURE__*/React.createElement("div", {
    className: "field-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Allergens to avoid"), /*#__PURE__*/React.createElement("div", {
    className: "chip-grid"
  }, Object.entries(allergenLabels).map(([id, a]) => /*#__PURE__*/React.createElement("button", {
    key: id,
    type: "button",
    className: 'chip ' + (data.allergens.includes(id) ? 'selected' : ''),
    onClick: () => toggleAllergen(id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "chip-emoji"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: a.icon,
    size: 16
  })), a.name, data.allergens.includes(id) && /*#__PURE__*/React.createElement("span", {
    className: "chip-x"
  }, "\u2713"))))), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Dietary preferences ", /*#__PURE__*/React.createElement("span", {
    className: "opt"
  }, "(we'll prioritise matching treats)")), /*#__PURE__*/React.createElement("div", {
    className: "toggle-grid"
  }, diets.map(d => /*#__PURE__*/React.createElement("div", {
    key: d.id,
    className: 'toggle-card ' + (data.diets.includes(d.id) ? 'selected' : ''),
    onClick: () => toggleDiet(d.id)
  }, /*#__PURE__*/React.createElement("div", {
    className: "tc-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: d.icon,
    size: 22
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tc-name"
  }, d.name), /*#__PURE__*/React.createElement("div", {
    className: "tc-desc"
  }, d.desc)))))), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Severe allergy alert? ", /*#__PURE__*/React.createElement("span", {
    className: "opt"
  }, "(optional, we'll handle prep separately)")), /*#__PURE__*/React.createElement("textarea", {
    className: "textarea",
    value: data.severe,
    onChange: e => setData({
      ...data,
      severe: e.target.value
    }),
    placeholder: "e.g. 'guest has anaphylaxis to peanuts, please bake their items first and seal separately'"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onBack
  }, "\u2190 Back"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    onClick: onNext
  }, "Continue \xB7 Choose treats \u2192")));
}

// ============= Step 3: Choose products =============
function StepProducts({
  cart,
  setQty,
  allergens,
  diets,
  onNext,
  onBack,
  density,
  products,
  categories
}) {
  const [category, setCategory] = React.useState('all');
  const visible = products.filter(p => {
    if (category !== 'all' && p.cat !== category) return false;
    if (allergens.some(a => (p.contains || []).includes(a))) return false;
    if (diets.includes('gf') && (p.contains || []).includes('g') && !p.gf) return false;
    return true;
  });
  const totalSelected = Object.values(cart).reduce((s, q) => s + q, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 03 \xB7 Pick your treats"), /*#__PURE__*/React.createElement("h2", null, "Build your box."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Mix and match anything you like. Quantities update your cart in real time on the right."), /*#__PURE__*/React.createElement("div", {
    className: "cat-tabs"
  }, categories.map(c => /*#__PURE__*/React.createElement("button", {
    key: c.id,
    type: "button",
    className: 'cat-tab ' + (category === c.id ? 'active' : ''),
    onClick: () => setCategory(c.id)
  }, c.name))), visible.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "callout"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      flexShrink: 0,
      color: 'var(--ink-soft)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search-empty",
    size: 22
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Nothing matches in this category"), "Your selected allergens filter out everything here. Try another category or revisit step 2.")) : /*#__PURE__*/React.createElement("div", {
    className: 'product-grid ' + (density === 'compact' ? 'dense' : '')
  }, visible.map(p => {
    const qty = cart[p.id] || 0;
    return /*#__PURE__*/React.createElement("div", {
      key: p.id,
      className: 'product-card ' + (qty > 0 ? 'has-qty' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "ph"
    }, p.image ? /*#__PURE__*/React.createElement("img", {
      src: p.image,
      alt: p.name,
      className: "ph-img"
    }) : /*#__PURE__*/React.createElement(Icon, {
      name: `cat-${p.cat}`,
      size: 64,
      className: "ph-icon"
    }), p.badge && /*#__PURE__*/React.createElement("span", {
      className: 'ph-badge ' + (p.badge === 'NEW' ? 'pink' : '')
    }, p.badge), qty > 0 && /*#__PURE__*/React.createElement("span", {
      className: "qty-badge"
    }, qty)), /*#__PURE__*/React.createElement("div", {
      className: "pc-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pc-name"
    }, p.name), /*#__PURE__*/React.createElement("div", {
      className: "pc-meta"
    }, p.desc), /*#__PURE__*/React.createElement("div", {
      className: "tags"
    }, p.gf && /*#__PURE__*/React.createElement("span", {
      className: "tag"
    }, "GF"), !(p.contains || []).includes('d') && !(p.contains || []).includes('e') && /*#__PURE__*/React.createElement("span", {
      className: "tag"
    }, "Vegan-ish"), (p.contains || []).includes('n') && /*#__PURE__*/React.createElement("span", {
      className: "tag warn"
    }, "Contains nuts")), /*#__PURE__*/React.createElement("div", {
      className: "pc-foot"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pc-price"
    }, fmt(p.price), " ", /*#__PURE__*/React.createElement("small", null, "/ ", p.unit)), /*#__PURE__*/React.createElement(QtyInput, {
      value: qty,
      min: 0,
      onChange: v => setQty(p.id, v)
    }))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onBack
  }, "\u2190 Back"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    disabled: totalSelected === 0,
    onClick: onNext
  }, totalSelected === 0 ? 'Add at least one treat' : `Continue - Review quantities \u2192`)));
}

// ============= Step 4: Bulk tier review =============
function StepBulk({
  cart,
  setQty,
  products,
  subtotal,
  discount,
  tiers,
  onNext,
  onBack,
  goToStep
}) {
  const productMap = Object.fromEntries(products.map(p => [p.id, p]));
  const items = Object.entries(cart).filter(([, q]) => q > 0);
  const sorted = [...tiers].sort((a, b) => a.threshold - b.threshold);
  const next = sorted.find(t => subtotal < t.threshold);
  const current = sorted.filter(t => subtotal >= t.threshold).pop();

  // Items whose price will push the subtotal across the next threshold (cheapest first).
  const gap = next ? next.threshold - subtotal : 0;
  const suggestions = next ? products.filter(p => p.price >= gap).filter(p => (cart[p.id] || 0) === 0).sort((a, b) => a.price - b.price).slice(0, 3) : [];
  const maxThreshold = sorted.length && sorted[sorted.length - 1].threshold > 0 ? sorted[sorted.length - 1].threshold : 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 04 \xB7 Quantities & bulk savings"), /*#__PURE__*/React.createElement("h2", null, "Maximise your bulk discount."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Review your treat counts. ", next ? `You're close to the next tier, a small bump could save you more.` : `You've unlocked the maximum tier. Nice work.`), /*#__PURE__*/React.createElement("div", {
    className: "tier-progress",
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier-headline"
  }, /*#__PURE__*/React.createElement("span", null, current ? `Currently saving ${(current.discount * 100).toFixed(0)}%` : 'No discount yet'), /*#__PURE__*/React.createElement("strong", null, fmt(subtotal), " subtotal")), /*#__PURE__*/React.createElement("div", {
    className: "tier-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tier-bar-fill",
    style: {
      width: Math.min(100, subtotal / maxThreshold * 100) + '%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "tier-ticks"
  }, sorted.map(t => /*#__PURE__*/React.createElement("div", {
    key: t.threshold,
    className: 'tier-tick ' + (subtotal >= t.threshold ? 'passed' : ''),
    style: { left: (t.threshold / maxThreshold * 100) + '%' }
  }, /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("span", null, fmt(t.threshold)), /*#__PURE__*/React.createElement("span", null, (t.discount * 100).toFixed(0), "%")))), next && /*#__PURE__*/React.createElement("div", {
    className: "tier-message"
  }, "Add ", /*#__PURE__*/React.createElement("strong", null, fmt(next.threshold - subtotal)), " more to unlock ", /*#__PURE__*/React.createElement("strong", null, (next.discount * 100).toFixed(0), "% off"), ", that's ", /*#__PURE__*/React.createElement("strong", null, fmt(next.threshold * next.discount - subtotal * (current?.discount || 0))), " in extra savings.")), suggestions.length > 0 && next && /*#__PURE__*/React.createElement("div", {
    className: "suggest-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ss-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "bulb",
    size: 18
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Almost there."), " Add one of these to cross ", fmt(next.threshold), ":"), /*#__PURE__*/React.createElement("div", {
    className: "ss-actions"
  }, suggestions.map(p => /*#__PURE__*/React.createElement("button", {
    key: p.id,
    type: "button",
    className: "btn btn-ghost btn-sm",
    onClick: () => setQty(p.id, 1)
  }, "+ ", p.name, " (", fmt(p.price), ")")))), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'Bricolage Grotesque',
      fontSize: 18,
      color: 'var(--navy)',
      margin: 0
    }
  }, "Your selections"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost btn-sm",
    onClick: () => goToStep(2)
  }, "+ Add more treats")), items.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "cart-empty",
    style: {
      padding: 40
    }
  }, /*#__PURE__*/React.createElement("div", null, "No treats selected yet, head back to step 3 to choose some.")) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, items.map(([id, qty]) => {
    const p = productMap[id];
    if (!p) return null;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      style: {
        display: 'grid',
        gridTemplateColumns: '48px 1fr auto auto',
        alignItems: 'center',
        gap: 14,
        padding: '12px 14px',
        border: '1.5px solid var(--line)',
        borderRadius: 'var(--radius-md)',
        background: 'var(--paper)'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "cart-thumb",
      style: {
        width: 48,
        height: 48,
        borderRadius: 10
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: `cat-${p.cat}`,
      size: 24
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 700,
        color: 'var(--navy)',
        fontSize: 14.5
      }
    }, p.name), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: 'var(--ink-soft)'
      }
    }, fmt(p.price), " per ", p.unit)), /*#__PURE__*/React.createElement(QtyInput, {
      value: qty,
      min: 0,
      onChange: v => setQty(id, v)
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 700,
        color: 'var(--navy)',
        minWidth: 72,
        textAlign: 'right'
      }
    }, fmt(p.price * qty)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onBack
  }, "\u2190 Back"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    disabled: items.length === 0,
    onClick: onNext
  }, "Continue \xB7 Delivery date \u2192")));
}

// ============= Step 5: Delivery =============
// Format a Date as YYYY-MM-DD using LOCAL components, toISOString() returns UTC,
// which drifts the date by a day in any non-UTC timezone (e.g. Melbourne ahead of UTC).
const toLocalISODate = d => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
function StepDelivery({
  data,
  blackouts,
  setData,
  onNext,
  onBack
}) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [view, setView] = React.useState(() => {
    const d = new Date(today);
    d.setDate(1);
    return d;
  });
  const blackoutDates = blackouts && blackouts.dates || [];
  const blackoutWeekdays = blackouts && blackouts.weekdays || [];
  const minLeadDays = blackouts && typeof blackouts.minLeadDays === 'number' ? blackouts.minLeadDays : 2;
  const minDate = new Date(today);
  minDate.setDate(today.getDate() + minLeadDays);
  const isBlackout = d => {
    const iso = toLocalISODate(d);
    if (blackoutDates.includes(iso)) return true;
    if (blackoutWeekdays.includes(d.getDay())) return true;
    return false;
  };
  const isPast = d => d < minDate;
  const monthLabel = view.toLocaleDateString('en-AU', {
    month: 'long',
    year: 'numeric'
  });
  const firstDow = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
  const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(view.getFullYear(), view.getMonth(), d));
  const selectDate = d => {
    setData({
      ...data,
      deliveryDate: toLocalISODate(d)
    });
  };
  const isSelected = d => data.deliveryDate === toLocalISODate(d);
  const isToday = d => d.toDateString() === today.toDateString();
  const windows = [{
    id: 'am',
    name: 'Morning',
    range: '9am - 12pm'
  }, {
    id: 'pm',
    name: 'Afternoon',
    range: '12pm - 4pm'
  }, {
    id: 'eve',
    name: 'Evening',
    range: '4pm - 7pm'
  }];
  const valid = data.deliveryDate && data.window && data.address.trim().length > 4;
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 05 \xB7 Delivery"), /*#__PURE__*/React.createElement("h2", null, "When & where?"), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "We deliver personally across Melbourne, no third-party couriers. Pick a date and we'll arrive in the window you choose."), /*#__PURE__*/React.createElement("div", {
    className: "delivery-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cal-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cal-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cal-title"
  }, monthLabel), /*#__PURE__*/React.createElement("div", {
    className: "cal-nav"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setView(new Date(view.getFullYear(), view.getMonth() - 1, 1))
  }, "\u2039"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setView(new Date(view.getFullYear(), view.getMonth() + 1, 1))
  }, "\u203A"))), /*#__PURE__*/React.createElement("div", {
    className: "cal-grid"
  }, ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => /*#__PURE__*/React.createElement("div", {
    key: d,
    className: "cal-dow"
  }, d)), cells.map((d, i) => {
    if (!d) return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "cal-day empty"
    });
    const cls = ['cal-day'];
    if (isPast(d)) cls.push('past', 'disabled');else if (isBlackout(d)) cls.push('disabled');
    if (isSelected(d)) cls.push('selected');
    if (isToday(d)) cls.push('today');
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: cls.join(' '),
      onClick: () => {
        if (!isPast(d) && !isBlackout(d)) selectDate(d);
      }
    }, d.getDate());
  })), /*#__PURE__*/React.createElement("div", {
    className: "cal-legend"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lg"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sw"
  }), " Selected"), /*#__PURE__*/React.createElement("span", {
    className: "lg"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sw today"
  }), " Today"), /*#__PURE__*/React.createElement("span", {
    className: "lg"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sw dis"
  }), " Unavailable"))), /*#__PURE__*/React.createElement("div", {
    className: "field-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Delivery window"), /*#__PURE__*/React.createElement("div", {
    className: "toggle-grid"
  }, windows.map(w => /*#__PURE__*/React.createElement("div", {
    key: w.id,
    className: 'toggle-card ' + (data.window === w.id ? 'selected' : ''),
    onClick: () => setData({
      ...data,
      window: w.id
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "tc-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: w.id === 'am' ? 'sunrise' : w.id === 'pm' ? 'sun' : 'moon',
    size: 22
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tc-name"
  }, w.name), /*#__PURE__*/React.createElement("div", {
    className: "tc-desc"
  }, w.range)))))), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Delivery address"), /*#__PURE__*/React.createElement("input", {
    className: "input",
    value: data.address,
    onChange: e => setData({
      ...data,
      address: e.target.value
    }),
    placeholder: "Street, suburb, postcode"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: 'var(--ink-soft)',
      marginTop: 4
    }
  }, "We deliver across Melbourne metro. Check zones in step 6.")), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Special instructions ", /*#__PURE__*/React.createElement("span", {
    className: "opt"
  }, "(optional)")), /*#__PURE__*/React.createElement("textarea", {
    className: "textarea",
    value: data.deliveryNotes,
    onChange: e => setData({
      ...data,
      deliveryNotes: e.target.value
    }),
    placeholder: "e.g. 'leave at reception', 'call on arrival', 'gate code 1234'"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onBack
  }, "\u2190 Back"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    disabled: !valid,
    onClick: onNext
  }, "Continue \xB7 Review & confirm \u2192")));
}

// ============= Step 6: Review =============
const DIET_LABELS = {
  vegan: 'Vegan',
  vegetarian: 'Vegetarian',
  gf: 'Gluten-free',
  halal: 'Halal',
  kosher: 'Kosher',
  nuts: 'Nut-free'
};
// Basic email format: local@domain.tld. Catches typos without false negatives on real addresses.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function StepReview({
  state,
  setState,
  products,
  subtotal,
  discount,
  tiers,
  occasions,
  allergenLabels,
  deliveryFlatFee,
  freeDeliveryOver,
  submitting,
  submitError,
  goToStep,
  onBack,
  onSubmit
}) {
  const productMap = Object.fromEntries(products.map(p => [p.id, p]));
  const items = Object.entries(state.cart).filter(([, q]) => q > 0);
  const flatFee = typeof deliveryFlatFee === 'number' ? deliveryFlatFee : 15;
  const freeOver = typeof freeDeliveryOver === 'number' ? freeDeliveryOver : 50;
  const deliveryCost = subtotal > freeOver ? 0 : flatFee;
  const total = subtotal - discount + deliveryCost;
  const emailOk = EMAIL_RE.test((state.contact.email || '').trim());
  const valid = state.contact.name.trim() && emailOk && state.contact.phone.trim() && items.length > 0 && !submitting;
  const fmtDate = iso => {
    if (!iso) return '--';
    const parts = iso.split('-').map(Number);
    if (parts.length !== 3 || parts.some(n => Number.isNaN(n))) return '--';
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString('en-AU', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  const occasion = occasions.find(o => o.id === state.event.occasion);
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Step 06 \xB7 Review & confirm"), /*#__PURE__*/React.createElement("h2", null, "One last look."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Check the details below, drop in your contact info, and we'll get baking."), /*#__PURE__*/React.createElement("div", {
    className: "field-row-3",
    style: {
      marginBottom: 22
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Your name"), /*#__PURE__*/React.createElement("input", {
    className: "input",
    value: state.contact.name,
    onChange: e => setState({
      ...state,
      contact: {
        ...state.contact,
        name: e.target.value
      }
    }),
    placeholder: "Full name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    className: "input",
    type: "email",
    value: state.contact.email,
    onChange: e => setState({
      ...state,
      contact: {
        ...state.contact,
        email: e.target.value
      }
    }),
    placeholder: "you@email.com"
  })), /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lbl"
  }, "Phone"), /*#__PURE__*/React.createElement("input", {
    className: "input",
    type: "tel",
    value: state.contact.phone,
    onChange: e => setState({
      ...state,
      contact: {
        ...state.contact,
        phone: e.target.value
      }
    }),
    placeholder: "04XX XXX XXX"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "review-sections"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-block"
  }, /*#__PURE__*/React.createElement("h4", null, "Event ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "edit-link",
    onClick: () => goToStep(0)
  }, "edit")), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Occasion"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, occasion ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: occasion.icon,
    size: 14
  }), " \xA0", occasion.name) : '--')), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Name"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, state.event.eventName || '--')), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Guests"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, state.event.guests || '--'))), /*#__PURE__*/React.createElement("div", {
    className: "review-block"
  }, /*#__PURE__*/React.createElement("h4", null, "Dietary ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "edit-link",
    onClick: () => goToStep(1)
  }, "edit")), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Avoid"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, state.dietary.allergens.length ? state.dietary.allergens.map(a => allergenLabels[a] && allergenLabels[a].name || a).join(', ') : 'None')), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Preferences"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, state.dietary.diets.length ? state.dietary.diets.map(d => DIET_LABELS[d] || d).join(', ') : 'None'))), /*#__PURE__*/React.createElement("div", {
    className: "review-block"
  }, /*#__PURE__*/React.createElement("h4", null, "Treats (", items.reduce((s, [, q]) => s + q, 0), " items) ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "edit-link",
    onClick: () => goToStep(2)
  }, "edit")), items.length === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      color: 'var(--ink-soft)'
    }
  }, "No items") : items.map(([id, qty]) => {
    const p = productMap[id];
    if (!p) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "review-row",
      key: id
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, qty, " \xD7 ", p.name), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, fmt(p.price * qty)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "review-block"
  }, /*#__PURE__*/React.createElement("h4", null, "Delivery ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "edit-link",
    onClick: () => goToStep(4)
  }, "edit")), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Date"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, fmtDate(state.delivery.deliveryDate))), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Window"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, state.delivery.window || '--')), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Address"), /*#__PURE__*/React.createElement("span", {
    className: "v",
    style: {
      maxWidth: 180,
      fontSize: 12
    }
  }, state.delivery.address || '--')))), /*#__PURE__*/React.createElement("div", {
    className: "review-block",
    style: {
      marginTop: 20,
      background: 'var(--cream)',
      borderColor: 'var(--pink-100)'
    }
  }, /*#__PURE__*/React.createElement("h4", null, "Total"), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Subtotal"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, fmt(subtotal))), discount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "review-row",
    style: {
      color: 'var(--ok)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Bulk discount"), /*#__PURE__*/React.createElement("span", {
    className: "v",
    style: {
      color: 'var(--ok)'
    }
  }, "\u2212", fmt(discount))), /*#__PURE__*/React.createElement("div", {
    className: "review-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Delivery"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, deliveryCost === 0 ? 'FREE' : fmt(flatFee))), /*#__PURE__*/React.createElement("div", {
    className: "review-row",
    style: {
      borderTop: '1px solid var(--line)',
      marginTop: 6,
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "k",
    style: {
      fontWeight: 700,
      color: 'var(--navy)',
      fontSize: 15
    }
  }, "Order total"), /*#__PURE__*/React.createElement("span", {
    className: "v",
    style: {
      fontFamily: 'Bricolage Grotesque',
      fontSize: 22
    }
  }, fmt(total))), discount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "review-row",
    style: {
      marginTop: 6,
      fontSize: 11,
      color: 'var(--ink-soft)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "k"
  }, "Bulk discount shown above is indicative, final discount is applied automatically at checkout."), /*#__PURE__*/React.createElement("span", null))), submitError && /*#__PURE__*/React.createElement("div", {
    className: "callout warn",
    style: {
      marginTop: 18
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      flexShrink: 0,
      color: 'var(--warn)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "warn",
    size: 22
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Something went wrong"), submitError)), /*#__PURE__*/React.createElement("div", {
    className: "step-actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onBack,
    disabled: submitting
  }, "\u2190 Back"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-pink",
    disabled: !valid,
    onClick: onSubmit
  }, submitting ? 'Sending to checkout\u2026' : `Place order - ${fmt(total)}`)));
}

// ============= Confirmation =============
function StepDone({
  state,
  onRestart
}) {
  const contact = state.contact || {};
  const firstName = (contact.name || '').trim().split(/\s+/)[0] || 'friend';
  return /*#__PURE__*/React.createElement("div", {
    className: "step-card",
    style: {
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 80,
      height: 80,
      borderRadius: '50%',
      background: 'var(--pink)',
      color: 'white',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '40px auto 20px',
      boxShadow: '0 16px 36px -16px rgba(239,124,142,0.6)'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))), /*#__PURE__*/React.createElement("h2", {
    style: {
      textAlign: 'center'
    }
  }, "You're all set, ", firstName, "."), /*#__PURE__*/React.createElement("p", {
    className: "lede",
    style: {
      textAlign: 'center',
      marginInline: 'auto'
    }
  }, contact.email ? /*#__PURE__*/React.createElement(React.Fragment, null, "We've sent a confirmation to ", /*#__PURE__*/React.createElement("strong", null, contact.email), ". We'll be in touch shortly with a final invoice and timing details.") : /*#__PURE__*/React.createElement(React.Fragment, null, "We'll be in touch shortly with a final invoice and timing details.")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-ghost",
    onClick: onRestart,
    style: {
      marginTop: 24
    }
  }, "Build another package"));
}
Object.assign(window, {
  StepEvent,
  StepDietary,
  StepProducts,
  StepBulk,
  StepDelivery,
  StepReview,
  StepDone,
  QtyInput
});


// Sweet Sprinkles Package Builder, Shopify-ready production app.
// Reads runtime configuration from window.SS_BUILDER_CONFIG (set by the Liquid section).
// On submit: POSTs all selected items to /cart/add.js with line-item properties,
// PUTs order-level details into cart attributes + note, then redirects to /checkout.

const STEPS = [{
  id: 'event',
  name: 'Event details',
  sub: 'Occasion & guests'
}, {
  id: 'dietary',
  name: 'Dietary & allergens',
  sub: 'Tell us what to avoid'
}, {
  id: 'products',
  name: 'Choose treats',
  sub: 'Build your box'
}, {
  id: 'bulk',
  name: 'Quantities',
  sub: 'Maximise bulk savings'
}, {
  id: 'delivery',
  name: 'Delivery',
  sub: 'When & where'
}, {
  id: 'review',
  name: 'Review & confirm',
  sub: 'Contact + finalise'
}];

// Built-in fallback when window.SS_BUILDER_CONFIG isn't injected (e.g. local preview).
// The Liquid section always overrides this.
const FALLBACK_CONFIG = {
  products: typeof window !== 'undefined' && window.SS_PRODUCTS || [],
  categories: typeof window !== 'undefined' && window.SS_CATEGORIES || [],
  allergenLabels: typeof window !== 'undefined' && window.SS_ALLERGEN_LABELS || {},
  occasions: typeof window !== 'undefined' && window.SS_OCCASIONS || [],
  tiers: typeof window !== 'undefined' && window.SS_DEFAULT_TIERS || [],
  blackouts: typeof window !== 'undefined' && window.SS_BLACKOUTS || {
    weekdays: [0, 1],
    dates: [],
    minLeadDays: 2
  },
  shopName: 'Sweet Sprinkles',
  logoUrl: 'assets/logo.png',
  cartAddUrl: '/cart/add.js',
  cartUpdateUrl: '/cart/update.js',
  checkoutUrl: '/checkout',
  moneyFormat: '${{amount}}',
  currency: 'AUD',
  deliveryFlatFee: 15,
  freeDeliveryOver: 50,
  layout: 'default',
  // 'default' | 'side' | 'compact'
  stepperStyle: 'numbered',
  // 'numbered' | 'dotted' | 'bar'
  density: 'regular',
  // 'comfy' | 'regular' | 'compact'
  theme: 'bakery',
  // 'bakery' | 'site' | 'forest'
  primaryColor: '#EF7C8E',
  navyColor: '#1F3D52',
  // When true, submit() will POST to Shopify cart endpoints + redirect to checkout.
  // When false (preview mode), submit() just shows the confirmation screen.
  shopifyMode: false
};

// Format a number as money using a Shopify-style format string like "${{amount}}" or
// "${{amount_no_decimals}}". Supports {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}.
function formatMoney(amount, format) {
  const fmt = format || '${{amount}}';
  const n = Number(amount) || 0;
  const placeholderRE = /\{\{\s*(\w+)\s*\}\}/g;
  return fmt.replace(placeholderRE, function (_, key) {
    if (key === 'amount') return (Math.round(n * 100) / 100).toFixed(2);
    if (key === 'amount_no_decimals') return String(Math.round(n));
    if (key === 'amount_with_comma_separator') return (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (key === 'amount_no_decimals_with_comma_separator') return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '';
  });
}
function PackageBuilder() {
  const config = React.useMemo(() => Object.assign({}, FALLBACK_CONFIG, typeof window !== 'undefined' && window.SS_BUILDER_CONFIG || {}), []);

  // Expose the active money formatter as a window helper so cart.jsx / steps.jsx can use it
  // without prop-drilling through every component.
  React.useEffect(() => {
    window.SS_FMT = n => formatMoney(n, config.moneyFormat);
  }, [config.moneyFormat]);
  const [step, setStep] = React.useState(0);
  const [furthest, setFurthest] = React.useState(0);
  const [done, setDone] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState('');
  const [state, setState] = React.useState({
    event: {
      occasion: '',
      eventName: '',
      guests: 25,
      notes: ''
    },
    dietary: {
      allergens: [],
      diets: [],
      severe: ''
    },
    cart: {},
    // { productId: qty }
    delivery: {
      deliveryDate: '',
      window: '',
      address: '',
      deliveryNotes: ''
    },
    contact: {
      name: '',
      email: '',
      phone: ''
    }
  });
  const products = config.products;
  const productMap = React.useMemo(() => Object.fromEntries(products.map(p => [p.id, p])), [products]);
  const subtotal = React.useMemo(() => Object.entries(state.cart).reduce((s, [id, q]) => s + (productMap[id]?.price || 0) * q, 0), [state.cart, productMap]);
  const tiers = config.tiers && config.tiers.length ? config.tiers : [];
  const sortedTiers = React.useMemo(() => [...tiers].sort((a, b) => a.threshold - b.threshold), [tiers]);
  const currentTier = sortedTiers.filter(x => subtotal >= x.threshold).pop();
  const discount = currentTier ? subtotal * currentTier.discount : 0;
  const setQty = (id, qty) => {
    setState(s => {
      const c = {
        ...s.cart
      };
      if (qty <= 0) delete c[id];else c[id] = qty;
      return {
        ...s,
        cart: c
      };
    });
  };
  const removeFromCart = id => setQty(id, 0);
  const goToStep = idx => {
    if (idx <= furthest) setStep(idx);
  };
  const next = () => {
    const nx = Math.min(STEPS.length - 1, step + 1);
    setStep(nx);
    setFurthest(f => Math.max(f, nx));
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const back = () => {
    setStep(s => Math.max(0, s - 1));
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const submit = async () => {
    setSubmitError('');
    if (!config.shopifyMode) {
      // Preview/dev mode: skip the cart POST and show the local confirmation screen.
      setDone(true);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    setSubmitting(true);
    try {
      const items = Object.entries(state.cart).filter(([, q]) => q > 0).map(([id, qty]) => {
        const p = productMap[id];
        if (!p || !p.variant_id) {
          throw new Error('Product "' + (p?.name || id) + '" is missing a Shopify variant ID. Add a variant_id to the product in the Liquid section.');
        }
        return {
          id: Number(p.variant_id),
          quantity: qty,
          properties: {
            'Event': state.event.eventName || '',
            'Occasion': state.event.occasion || '',
            'Guest count': String(state.event.guests || '')
          }
        };
      });
      if (items.length === 0) throw new Error('Your package is empty.');

      // 1. Clear any existing cart so the builder's items aren't merged with pre-existing ones.
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        }
      });

      // 2. Add all selected items.
      const addRes = await fetch(config.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items
        })
      });
      if (!addRes.ok) {
        const errBody = await addRes.json().catch(() => ({}));
        throw new Error(errBody.description || errBody.message || 'Cart add failed (HTTP ' + addRes.status + ')');
      }

      // 3. Attach order-level metadata as cart attributes + note. Attributes show up in
      //    the Shopify order admin; note is shown to the customer at checkout.
      const allergenNames = state.dietary.allergens.map(a => config.allergenLabels[a] && config.allergenLabels[a].name || a).join(', ');
      const dietNames = state.dietary.diets.join(', ');
      const occasion = (config.occasions.find(o => o.id === state.event.occasion) || {}).name || state.event.occasion;
      const attributes = {
        'Event name': state.event.eventName || '',
        'Occasion': occasion || '',
        'Guest count': String(state.event.guests || ''),
        'Allergens to avoid': allergenNames || 'None',
        'Dietary preferences': dietNames || 'None',
        'Severe allergy alert': state.dietary.severe || '',
        'Delivery date': state.delivery.deliveryDate || '',
        'Delivery window': state.delivery.window || '',
        'Delivery address': state.delivery.address || '',
        'Delivery notes': state.delivery.deliveryNotes || '',
        'Contact name': state.contact.name || '',
        'Contact email': state.contact.email || '',
        'Contact phone': state.contact.phone || '',
        'Event notes': state.event.notes || ''
      };
      // Strip empty attributes so they don't clutter the admin order view.
      const cleanAttrs = {};
      Object.keys(attributes).forEach(k => {
        if (attributes[k]) cleanAttrs[k] = attributes[k];
      });
      const noteLines = ['Sweet Sprinkles package builder', state.event.eventName ? 'Event: ' + state.event.eventName : '', occasion ? 'Occasion: ' + occasion : '', state.event.guests ? 'Guests: ' + state.event.guests : '', state.delivery.deliveryDate ? 'Delivery: ' + state.delivery.deliveryDate + ' (' + (state.delivery.window || '') + ')' : '', allergenNames ? 'Allergens: ' + allergenNames : '', state.dietary.severe ? 'SEVERE ALLERGY: ' + state.dietary.severe : ''].filter(Boolean).join('\n');
      const updateRes = await fetch(config.cartUpdateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: cleanAttrs,
          note: noteLines
        })
      });
      if (!updateRes.ok) {
        // Items were added but metadata failed, still proceed to checkout so the customer
        // can finish; surface a console warning for the merchant.
        console.warn('Sweet Sprinkles: cart attributes update failed', updateRes.status);
      }

      // 4. Redirect to checkout. From here Shopify handles payment.
      window.location.href = config.checkoutUrl;
    } catch (err) {
      console.error('Sweet Sprinkles submit error', err);
      setSubmitError(err.message || 'Sorry, we couldn\u2019t add your package to the cart. Please try again or contact us.');
      setSubmitting(false);
    }
  };
  const restart = () => {
    setDone(false);
    setStep(0);
    setFurthest(0);
    setSubmitError('');
    setState({
      event: {
        occasion: '',
        eventName: '',
        guests: 25,
        notes: ''
      },
      dietary: {
        allergens: [],
        diets: [],
        severe: ''
      },
      cart: {},
      delivery: {
        deliveryDate: '',
        window: '',
        address: '',
        deliveryNotes: ''
      },
      contact: {
        name: '',
        email: '',
        phone: ''
      }
    });
  };

  // Apply colour tokens to the document root once at mount, based on the Liquid-injected theme.
  React.useEffect(() => {
    const r = document.documentElement;
    const theme = config.theme || 'bakery';
    r.setAttribute('data-theme', theme);
    if (theme === 'forest') {
      r.style.setProperty('--cream', '#4B6F44');
      r.style.setProperty('--cream-2', '#3F5F39');
      r.style.setProperty('--paper', '#557B4E');
      r.style.setProperty('--navy', '#000000');
      r.style.setProperty('--navy-700', '#000000');
      r.style.setProperty('--navy-300', '#A8BCA4');
      r.style.setProperty('--ink', '#F1F4F0');
      r.style.setProperty('--ink-soft', 'rgba(241, 244, 240, 0.72)');
      r.style.setProperty('--line', '#608E57');
      r.style.setProperty('--line-soft', '#557B4E');
      r.style.setProperty('--link', '#F1F3F4');
      r.style.setProperty('--link-hover', '#FFFFFF');
      r.style.setProperty('--pink', config.primaryColor);
      r.style.setProperty('--pink-600', shade(config.primaryColor, -10));
      r.style.setProperty('--pink-100', 'rgba(241, 244, 240, 0.16)');
      r.style.setProperty('--pink-50', 'rgba(241, 244, 240, 0.08)');
    } else if (theme === 'site') {
      const FOREST = '#284323';
      r.style.setProperty('--accent-pink', '#EF7C8E');
      r.style.setProperty('--cream', '#FBFAF6');
      r.style.setProperty('--cream-2', '#EFECE3');
      r.style.setProperty('--paper', '#FFFFFF');
      r.style.setProperty('--navy', '#121212');
      r.style.setProperty('--navy-700', '#000000');
      r.style.setProperty('--navy-300', '#8A8A88');
      r.style.setProperty('--ink', '#1F1F1F');
      r.style.setProperty('--ink-soft', '#6E6E6E');
      r.style.setProperty('--line', '#E6E3DB');
      r.style.setProperty('--line-soft', '#F2EFE7');
      r.style.setProperty('--banner-bg', FOREST);
      r.style.setProperty('--banner-fg', '#FFFFFF');
      r.style.setProperty('--link', FOREST);
      r.style.setProperty('--link-hover', '#1B2F18');
      r.style.setProperty('--pink', FOREST);
      r.style.setProperty('--pink-600', '#1B2F18');
      r.style.setProperty('--pink-100', '#D8E2D5');
      r.style.setProperty('--pink-50', '#F0F4EE');
    } else {
      r.style.setProperty('--cream', '#FBF6EE');
      r.style.setProperty('--cream-2', '#F4ECDE');
      r.style.setProperty('--paper', '#FFFFFF');
      r.style.setProperty('--navy', config.navyColor);
      r.style.setProperty('--navy-700', shade(config.navyColor, -10));
      r.style.setProperty('--navy-300', '#6B8294');
      r.style.setProperty('--ink', shade(config.navyColor, -20));
      r.style.setProperty('--ink-soft', '#4F6271');
      r.style.setProperty('--line', '#E8DDC8');
      r.style.setProperty('--line-soft', '#F0E6D2');
      r.style.setProperty('--pink', config.primaryColor);
      r.style.setProperty('--pink-600', shade(config.primaryColor, -12));
      r.style.setProperty('--pink-100', tint(config.primaryColor, 78));
      r.style.setProperty('--pink-50', tint(config.primaryColor, 92));
    }
  }, [config.primaryColor, config.navyColor, config.theme]);
  const layoutClass = 'builder ' + (config.layout === 'side' ? 'layout-side' : config.layout === 'compact' ? 'layout-compact' : '');
  const renderStep = () => {
    if (done) return /*#__PURE__*/React.createElement(StepDone, {
      state: {
        contact: state.contact || {}
      },
      onRestart: restart
    });
    switch (step) {
      case 0:
        return /*#__PURE__*/React.createElement(StepEvent, {
          data: state.event,
          occasions: config.occasions,
          setData: d => setState(s => ({
            ...s,
            event: d
          })),
          onNext: next
        });
      case 1:
        return /*#__PURE__*/React.createElement(StepDietary, {
          data: state.dietary,
          allergenLabels: config.allergenLabels,
          setData: d => setState(s => ({
            ...s,
            dietary: d
          })),
          onNext: next,
          onBack: back
        });
      case 2:
        return /*#__PURE__*/React.createElement(StepProducts, {
          cart: state.cart,
          setQty: setQty,
          allergens: state.dietary.allergens,
          diets: state.dietary.diets,
          products: products,
          categories: config.categories,
          density: config.density,
          onNext: next,
          onBack: back
        });
      case 3:
        return /*#__PURE__*/React.createElement(StepBulk, {
          cart: state.cart,
          setQty: setQty,
          products: products,
          subtotal: subtotal,
          discount: discount,
          tiers: sortedTiers,
          goToStep: goToStep,
          onNext: next,
          onBack: back
        });
      case 4:
        return /*#__PURE__*/React.createElement(StepDelivery, {
          data: state.delivery,
          blackouts: config.blackouts,
          setData: d => setState(s => ({
            ...s,
            delivery: d
          })),
          onNext: next,
          onBack: back
        });
      case 5:
        return /*#__PURE__*/React.createElement(StepReview, {
          state: state,
          setState: setState,
          products: products,
          subtotal: subtotal,
          discount: discount,
          tiers: sortedTiers,
          occasions: config.occasions,
          allergenLabels: config.allergenLabels,
          deliveryFlatFee: config.deliveryFlatFee,
          freeDeliveryOver: config.freeDeliveryOver,
          submitting: submitting,
          submitError: submitError,
          goToStep: goToStep,
          onBack: back,
          onSubmit: submit
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    logoUrl: config.logoUrl,
    shopName: config.shopName
  }), /*#__PURE__*/React.createElement(PageHead, {
    step: step,
    done: done
  }), config.layout === 'default' && !done && /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: '0 auto',
      padding: '0 32px'
    }
  }, /*#__PURE__*/React.createElement(TopProgress, {
    step: step,
    furthest: furthest,
    goToStep: goToStep,
    stepperStyle: config.stepperStyle
  })), /*#__PURE__*/React.createElement("div", {
    className: layoutClass
  }, config.layout === 'side' && !done && /*#__PURE__*/React.createElement(Stepper, {
    step: step,
    furthest: furthest,
    goToStep: goToStep,
    stepperStyle: config.stepperStyle
  }), /*#__PURE__*/React.createElement("main", null, renderStep()), !done && /*#__PURE__*/React.createElement(CartSidebar, {
    cart: state.cart,
    products: products,
    subtotal: subtotal,
    discount: discount,
    tiers: sortedTiers,
    deliveryFlatFee: config.deliveryFlatFee,
    freeDeliveryOver: config.freeDeliveryOver,
    removeFromCart: removeFromCart,
    setQty: setQty,
    goToStep: goToStep,
    eventDetails: state.event
  })), /*#__PURE__*/React.createElement(SiteFooter, {
    shopName: config.shopName
  }));
}

// ============= Nav =============
function Nav({
  logoUrl,
  shopName
}) {
  return /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
    className: "nav-allergy"
  }, "Our kitchen handles nuts, peanuts, dairy, eggs, wheat & other common allergens."), /*#__PURE__*/React.createElement("div", {
    className: "nav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    alt: shopName
  })), /*#__PURE__*/React.createElement("nav", {
    className: "nav-links"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "Home"), /*#__PURE__*/React.createElement("a", {
    href: "/collections/all"
  }, "Order"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "active"
  }, "Special Order"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/information"
  }, "Information"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/contact"
  }, "Contact")), /*#__PURE__*/React.createElement("div", {
    className: "nav-icons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "icon-btn",
    type: "button",
    title: "Search",
    "aria-label": "Search"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 21-4.3-4.3"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "icon-btn",
    href: "/account",
    title: "Account",
    "aria-label": "Account"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "8",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21a8 8 0 0 1 16 0"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "icon-btn",
    href: "/cart",
    title: "Cart",
    "aria-label": "Cart"
  }, /*#__PURE__*/React.createElement(CartIcon, null))))));
}

// ============= Page head =============
function PageHead({
  step,
  done
}) {
  if (done) {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "eyebrow"
    }, "Confirmation"), /*#__PURE__*/React.createElement("h1", null, "Order received."), /*#__PURE__*/React.createElement("p", null, "Thanks for choosing Sweet Sprinkles, we're already prepping your treats.")));
  }
  const pct = (step + 1) / STEPS.length * 100;
  return /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Bulk & Catering"), /*#__PURE__*/React.createElement("h1", null, "Build your package."), /*#__PURE__*/React.createElement("p", null, "Catering for an event, office, or celebration? Mix and match our baked goods, and the more you order, the more you save.")), /*#__PURE__*/React.createElement("div", {
    className: "head-meta"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step-pill"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sp-num"
  }, step + 1, /*#__PURE__*/React.createElement("span", {
    className: "sp-of"
  }, "/", STEPS.length)), /*#__PURE__*/React.createElement("span", {
    className: "sp-name"
  }, STEPS[step]?.name)), /*#__PURE__*/React.createElement("div", {
    className: "sp-track"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sp-track-fill",
    style: {
      width: pct + '%'
    }
  }))));
}

// ============= Side stepper =============
function Stepper({
  step,
  furthest,
  goToStep,
  stepperStyle
}) {
  return /*#__PURE__*/React.createElement("aside", {
    className: 'stepper style-' + (stepperStyle || 'numbered')
  }, /*#__PURE__*/React.createElement("h3", null, "Your progress"), STEPS.map((s, i) => {
    const cls = ['step-item'];
    if (i === step) cls.push('active');else if (i < step) cls.push('done');
    if (i > furthest) cls.push('locked');
    return /*#__PURE__*/React.createElement("div", {
      key: s.id,
      className: cls.join(' '),
      onClick: () => i <= furthest && goToStep(i)
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-marker"
    }, i < step ? '\u2713' : i + 1), /*#__PURE__*/React.createElement("div", {
      className: "step-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-name"
    }, s.name), /*#__PURE__*/React.createElement("div", {
      className: "step-sub"
    }, s.sub)), i < STEPS.length - 1 && /*#__PURE__*/React.createElement("div", {
      className: "step-connector"
    }));
  }));
}

// ============= Top progress =============
function TopProgress({
  step,
  furthest,
  goToStep,
  stepperStyle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'top-progress style-' + (stepperStyle || 'numbered')
  }, STEPS.map((s, i) => {
    const status = i === step ? 'active' : i < step ? 'done' : 'upcoming';
    const cls = ['tp-step', 'status-' + status];
    if (i > furthest) cls.push('locked');
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: s.id
    }, /*#__PURE__*/React.createElement("div", {
      className: cls.join(' '),
      onClick: () => i <= furthest && goToStep(i)
    }, /*#__PURE__*/React.createElement("div", {
      className: 'step-marker is-' + status
    }, i < step ? /*#__PURE__*/React.createElement(Icon, {
      name: "check",
      size: 14,
      stroke: 2.6
    }) : i + 1), /*#__PURE__*/React.createElement("div", {
      className: "step-name"
    }, s.name)), i < STEPS.length - 1 && /*#__PURE__*/React.createElement("div", {
      className: 'tp-bar ' + (i < step ? 'done' : '')
    }));
  }));
}

// ============= Footer =============
function SiteFooter({
  shopName
}) {
  return /*#__PURE__*/React.createElement("footer", {
    className: "site-footer"
  }, /*#__PURE__*/React.createElement("div", null, shopName, " \xB7 Melbourne home-based bakery \xB7 Fresh, preservative-free baking, delivered."));
}

// ============= Color helpers =============
function hexToRgb(hex) {
  let h = String(hex || '').replace('#', '').trim();
  if (h.length === 3) h = h.split('').map(c => c + c).join('');
  if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return [0, 0, 0];
  return [h.slice(0, 2), h.slice(2, 4), h.slice(4, 6)].map(s => parseInt(s, 16));
}
function rgbToHex([r, g, b]) {
  const c = n => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');
  return '#' + c(r) + c(g) + c(b);
}
function shade(hex, pct) {
  const [r, g, b] = hexToRgb(hex);
  const f = n => n + (pct < 0 ? n * pct / 100 : (255 - n) * pct / 100);
  return rgbToHex([f(r), f(g), f(b)]);
}
function tint(hex, pct) {
  const [r, g, b] = hexToRgb(hex);
  const m = n => n + (255 - n) * (pct / 100);
  return rgbToHex([m(r), m(g), m(b)]);
}

// ============= Mount =============
// Prefer a section-specific container (avoids colliding with theme-level #root in Shopify);
// fall back to #root for the local preview HTML.
(function mountSweetSprinkles() {
  var el = document.getElementById('sweet-sprinkles-root') || document.getElementById('root');
  if (!el) {
    console.error('Sweet Sprinkles: no #sweet-sprinkles-root or #root element found.');
    return;
  }
  var root = ReactDOM.createRoot(el);
  root.render(React.createElement(PackageBuilder, null));
})();

